export default __webpack_public_path__ + "static/media/tag_blue.c1322431.svg";